import { useState } from "react";
import { useDispatch } from "react-redux";
import { exportPollParticipants, openParticipantModel } from "../../store/slices/pollSlice";
import { exportToCSV } from "../../helpers/utils";
import { Spinner } from "react-bootstrap"; // Import Bootstrap Spinner

const AnswerCell = ({ answerIndex, answer, totalVotesCount }) => {
    let range = answer.votesCount ?  Math.round((answer.votesCount / totalVotesCount) * 100) : 0;
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false); // Loader state

    const exportUsers = (answerId) => {
        setIsLoading(true); // Start loader
        dispatch(exportPollParticipants({ id : answerId }))
            .unwrap()
            .then(response => exportToCSV(response, `Users_${answer.attributes.title}_Answer${answerIndex + 1}`))
            .finally(() => setIsLoading(false)); // Stop loader after export
    };

    const openModel = (answerId)=>{
            dispatch(openParticipantModel(answerId));
    }

    return (
        <div className="answer-div">
            <div className="answer-row">
                <div className="mb-1">
                    <div className="answer-heading ">
                        Answer {answerIndex + 1}.
                    </div>
                    <div className="answer-inner-section">
                        <div className="rangeDiv" style={{ width: `${range}%` }}></div>
                        <div className="div1">
                            <div className="text-wrap">{answer.attributes.title}</div>
                            <div> {range}% <span className='f-10'>({answer.votesCount ?? 0} votes) </span></div>
                        </div>
                    </div>
                    <div className='export-div mt-2'>
                        <button 
                            className='btn btn-sm f-11 btn-dark py-1' 
                            onClick={() => exportUsers(answer?.id)}
                            disabled={(isLoading || answer.votesCount == 0) ? true : false } // Disable while loading
                        >
                            {isLoading ? ( // Show loader when exporting
                                <>
                                    <Spinner animation="border" size="sm" className="me-1" /> Exporting...
                                </>
                            ) : "Export Users"}
                        </button>
                    </div>
                </div>
            </div>
            <div className='ml-3 '>
                <button className='btn btn-sm f-11 btn-primary py-1' 
                disabled={(answer.votesCount == 0) ? true : false }
                onClick={()=>{
                    openModel(answer?.id);
                }}>Participant(s)</button>
            </div>
        </div>
    );
};

export default AnswerCell;
